import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import { hasLocationChanged } from 'apps/analytics';
import CacheableSet from 'utils/CacheableSet';
import { gtm } from 'apps/gtm/index';

const sendProductImpressionsToGTM = (fopImpressions, useSectionTitleAsListName, context) => {
  if (!fopImpressions.length) {
    return;
  }

  const {
    gtmPageType: pageType,
    gtmNumberOfResults: numberOfResults,
    gtmSortBy: sortBy,
    gtmFilterValues: filterValues,
  } = context;

  gtm.trigger('gtm:productImpressions', {
    pageType,
    numberOfResults,
    sortBy,
    filterValues,
    productImpressionsData: [...fopImpressions],
    useSectionTitleAsListName,
  });
};

const sendPromotionImpressionsToGTM = (promoImpressions, context) => {
  if (!promoImpressions.length) {
    return;
  }

  const { gtmPageType: pageType } = context;
  gtm.trigger('gtm:promotionImpressions', {
    pageType,
    promotionImpressionsData: [...promoImpressions],
  });
};

class FopImpressionsContainer extends PureComponent {
  static propTypes = {
    location: PropTypes.object,
    children: PropTypes.node.isRequired,
    useSectionTitleAsListName: PropTypes.bool,
    skipAnalytics: PropTypes.bool,
  };

  static contextTypes = {
    gtmPageType: PropTypes.string,
    gtmNumberOfResults: PropTypes.number,
    gtmSortBy: PropTypes.string,
    gtmFilterValues: PropTypes.string,
  };

  static childContextTypes = {
    gtmPageType: PropTypes.string,
    recordProductImpression: PropTypes.func.isRequired,
    recordPromotionImpression: PropTypes.func.isRequired,
  };

  static defaultProps = {
    useSectionTitleAsListName: false,
  };

  constructor(props) {
    super(props);
    this.fopImpressionSet = new CacheableSet(({ uid }) => uid);
    this.promoImpressionSet = new CacheableSet(({ uid }) => uid);
  }

  getChildContext() {
    return {
      recordProductImpression: this.recordProductImpression,
      recordPromotionImpression: this.recordPromotionImpression,
    };
  }

  componentDidMount() {
    if (this.props.skipAnalytics) {
      return;
    }

    this.sendProductImpressions();
    this.sendPromotionImpressions();
  }

  UNSAFE_componentWillUpdate(nextProps) {
    if (hasLocationChanged(this.props.location, nextProps.location)) {
      this.fopImpressionSet.clear();
      this.promoImpressionSet.clear();
    }
  }

  componentDidUpdate() {
    if (this.props.skipAnalytics) {
      return;
    }
    this.sendProductImpressions();
    this.sendPromotionImpressions();
  }

  componentWillUnmount() {
    this.fopImpressionSet.clear();
    this.promoImpressionSet.clear();
  }

  recordProductImpression = (singleFopImpressionData) => {
    this.fopImpressionSet.enqueue(singleFopImpressionData);
  };

  recordPromotionImpression = (singlePromotionImpressionData) => {
    this.promoImpressionSet.enqueue(singlePromotionImpressionData);
  };

  sendProductImpressions = () => {
    const { useSectionTitleAsListName } = this.props;
    const fopImpressions = this.fopImpressionSet.popAll();

    sendProductImpressionsToGTM(fopImpressions, useSectionTitleAsListName, this.context);
  };

  sendPromotionImpressions = () => {
    const promoImpressions = this.promoImpressionSet.popAll();

    sendPromotionImpressionsToGTM(promoImpressions, this.context);
  };

  render = () => this.props.children;
}

export default withRouter(FopImpressionsContainer);
